import { styled as muiStyled } from '@mui/material'

export const HIWContentCardContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    gap: 2px;
    flex-direction: column;
    font-size: 22px;
    color: #000;
    .index-heading {
        font-size: 1.5em;
        margin-right: 5px;
    }
    .main-heading {
        font-size: 0.8em;
        font-weight: 400;
        margin: 0;
    }
    .description {
        font-size: 0.6em;
        font-weight: 200;
    }
    @media(min-width: 768px){
      font-size: 28px;
    }
`,
)

export const HIWContentCardLine = muiStyled('hr')(
  ({ theme }) => `
  margin: 10px 0;
  color: #6655AB;
  opacity: 1;
  border-top: 2px solid;
`,
)
